<template>
    <section class="page-dashbord-monitoring"></section>
</template>

<script>
export default {
    name: 'page-dashbord-monitoring',

}
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-monitoring {
  .box-clear;
}
</style>


// WEBPACK FOOTER //
// src/pages/dashboard/monitoring.vue